import {createFileRoute} from "@tanstack/react-router";
import {profileNavigationItems} from "@/common/const/profile/navigation.const.profile";
import {clsx} from "@/utils/clsx";
import styles from "./index.module.scss";
import {Tabs} from "@/components/ui/Tabs/Tabs";
import {useTranslation} from "react-i18next";

export const Route = createFileRoute("/_mainLayout/profile/")({
  component: RouteComponent,
});

function RouteComponent() {
  const {t: tPage} = useTranslation("page");
  const {t: tHeader} = useTranslation("header");

  return (
    <div className={styles.profile}>
      <h1 className={styles.title}>{tHeader("title.profile")}</h1>
      <Tabs
        items={profileNavigationItems.map((item) => ({
          label: tPage(`tabs.${item.key.toLowerCase()}`),
          ...item,
        }))}
        className={clsx(styles.mobileTabs)}
      />
    </div>
  );
}
